import { render, staticRenderFns } from "./ContratoModalCancelamento.vue?vue&type=template&id=b0b81c20&scoped=true"
import script from "./ContratoModalCancelamento.vue?vue&type=script&lang=js"
export * from "./ContratoModalCancelamento.vue?vue&type=script&lang=js"
import style0 from "./ContratoModalCancelamento.vue?vue&type=style&index=0&id=b0b81c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b81c20",
  null
  
)

export default component.exports